import { useAuth0 } from "@auth0/auth0-react";
import Button from "components/button/Button";
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from "components/Dialog";
import InfoTooltip from "components/InfoTooltip";
import Editor from "components/Editor/Editor";
import { InputField } from "components/InputField/InputField";
import MyButton from "components/MyButton/index";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { useFormik } from "formik";
import htmlToDraft from "html-to-draftjs";
import AuthService from "Lib/API/Auth";
import FinanceSetting from "Lib/API/FinanceSetting/FinanceSetting";
import React, { useEffect, useRef, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Link } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { setTagType } from "services/api/communication";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import { emailRegex } from "utils/validation";
import { CommunicationSection } from "./CommunicationSection/CommunicationSection";
import "./index.scss";
import { TwiliioSetup } from "./TwiliioSetup/TwiliioSetup";
const TemplatesSetting = () => {
  const emailEditorRef = useRef({ projectId: 195575 });

  const { getAccessTokenSilently } = useAuth0();
  const [currentId, setCurrentId] = useState(null);
  const [enableEdit, setEnableEdit] = useState(false);
  const [editCommunications, setEditCommunications] = useState(false);
  const [descriptionValue, setDescriptionValue] = useState("");
  const [templateContent, setTemplateContent] = useState("");
  const [jsonContent, setJsonContent] = useState({});
  const [htmlContent, setHtmlContent] = useState("");
  const [oneTemplateLoading, setOneTemplateLoading] = useState(false);
  const [updateTemplateLoading, setUpdateTemplateLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [tokenList, setTokenList] = useState([]);
  const [templateById, setTemplateById] = useState();
  const [isTwilioFieldCleared, setIsTwilioFieldCleared] = useState(false);
  // const [tagType, setTagType] = useState("communications");
  const dispatch = useDispatch()
  const {tagType} =useSelector(state =>state.communication)

  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      twiliioAccount: {
        accountSid: orgData?.twilio?.accountSid,
        accountToken: orgData?.twilio?.accountToken,
        phoneNumberFrom: orgData?.twilio?.phoneNumberFrom,
      },
      education: {
        registrationEmail: orgData?.communication?.education?.registrationEmail,
        approvalEmail: orgData?.communication?.education?.approvalEmail,
        rejectEmail: orgData?.communication?.education?.rejectEmail,
      },
      donation: {
        donationBill: orgData?.communication?.donation?.donationBill,
        donationWithoutTribute: orgData?.communication?.donation?.donationWithoutTribute,
        donationWithTribute: orgData?.communication?.donation?.donationWithTribute,
        donationRecipient: orgData?.communication?.donation?.donationRecipient,
      },
      email: {
        replyTo: orgData?.communication?.email?.replyTo,
      },
      replyTo: templateById?.replyTo === null ? "" : templateById?.replyTo,
      useDefault: templateById?.useDefault,
      addLogo: templateById?.addLogo,
    },
    validationSchema: "",
  });
  const handleResetCommunications = () => {
    formik.resetForm({
      education: {
        registrationEmail: orgData?.communication?.education?.registrationEmail,
        approvalEmail: orgData?.communication?.education?.approvalEmail,
        rejectEmail: orgData?.communication?.education?.rejectEmail,
      },
      donation: {
        donationBill: orgData?.communication?.donation?.donationBill,
        donationWithoutTribute: orgData?.communication?.donation?.donationWithoutTribute,
        donationWithTribute: orgData?.communication?.donation?.donationWithTribute,
        donationRecipient: orgData?.communication?.donation?.donationRecipient,
      },
      email: {
        replyTo: orgData?.communication?.email?.replyTo,
      },
    });
  };
  const handleResetTwiliioAccount = () => {
    formik.resetForm({
      twiliioAccount: {
        accountSid: orgData?.twilio?.accountSid,
        accountToken: orgData?.twilio?.accountToken,
        phoneNumberFrom: orgData?.twilio?.phoneNumberFrom,
      },
    });
  };
  const buttons = [
    {
      name: "Cancel",
      action: () => {
        setEnableEdit(false);
        setEditCommunications(false);
        handleOnChange(templateById?.replyTo);

        formik.setFieldValue("email.error", false);

        tagType !== "communications" &&
          tagType !== "twiliio" &&
          toggleEditorPreview("hide");
        tagType === "communications" && handleResetCommunications();
        tagType === "twiliio" && handleResetTwiliioAccount();
      },
      isDisabled: false,
      type: "secondary",
      width: "100px",
      variant: "primary-outline",
    },
    {
      name: "Save",
      action: () => {
        updateCommunications();
      },
      width: "100px",
      isDisabled:
        tagType === "twiliio" ? (
        (!formik.values.twiliioAccount?.accountSid ||
          !formik.values.twiliioAccount?.accountToken ||
          !formik.values.twiliioAccount?.phoneNumberFrom) ||
          !isTwilioFieldCleared) : false,
      type: "primary",
      variant: "primary",
    },
  ];

  const tokenTypes = {
    yehrzeit: "deceased",
    event: "event",
    form: "form",
    education: "education",
    donation: "donation",
    invitation: "invitation",
  };

  const getTemplateTokens = async (type) => {
    const fileType = tokenTypes[type] || "document";
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateTokens(token, fileType);
      const tokens = response?.result;
      setTokenList(tokens);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };

  const updateCommunications = async () => {
    setUpdateTemplateLoading(true);
    let data;
    const token = await getAccessTokenSilently();
    tagType !== "communications"
      ? (data = {
          org_Id: getOrganizationInfoFromLocalStorage()?._id,
          twilio: {
            accountSid: formik.values.twiliioAccount?.accountSid,
            accountToken: formik.values.twiliioAccount?.accountToken,
            phoneNumberFrom: formik.values.twiliioAccount?.phoneNumberFrom,
          },
          communication: {
            education: {
              ...formik.values?.education,
            },
            donation: {
              ...formik.values?.donation,
            },
            email: {
              replyTo: formik.values?.email?.replyTo,
            },
          },
        })
      : (data = {
          org_Id: getOrganizationInfoFromLocalStorage()?._id,
          communication: {
            education: {
              ...formik.values?.education,
            },
            donation: {
              ...formik.values?.donation,
            },
            email: {
              replyTo: formik.values?.email?.replyTo,
            },
          },
        });
    if (token) {
      try {
        const response = await AuthService.updateCommunicationSettings(
          data,
          token
        );
        setIsTwilioFieldCleared(false);
        toastr.success("Communications updated successfully");
        setEditCommunications(false);
        setUpdateTemplateLoading(false);
        updateOrganization();
      } catch (error) {
        toastr.error("Error", error?.data?.message ?? "Something went wrong");
        setUpdateTemplateLoading(false);
      }
    } else {
      toastr.error("Error", "Something went wrong");
    }
  };

  const updateOrganization = async () => {
    const token = await getAccessTokenSilently();
    AuthService.getUserExist(token)
      .then((res) => {
        localStorage.setItem(
          "organization",
          JSON.stringify(res?.user?.permissions?.organization)
        );
      })
      .catch((err) => {
        toastr.error("Error", "Something went wrong");
      });
  };

  const deleteTemplate = async (id) => {
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.deleteTemplateById(token, id);
      toastr.success("Template deleted successfully");
      setRefresh(!refresh);
      dispatch(setTagType("communications"));
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };

  let editorState;
  useEffect(() => {
    if (templateContent) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      editorState = EditorState.createWithContent(
        ContentState.createFromBlockArray(htmlToDraft(templateContent))
      );
      setDescription(editorState);
    } else {
      editorState = EditorState.createEmpty();
      setDescription(editorState);
    }
  }, [templateContent, enableEdit]);

  const [description, setDescription] = useState(editorState);

  // Configuration options for the Image plugin

  const handleOnChange = (value) => {
    formik.setFieldValue("replyTo", value);
    if (!value) {
      formik.setFieldValue("error", false);
    } else {
      !emailRegex.test(value)
        ? formik.setFieldValue("error", true)
        : formik.setFieldValue("error", false);
    }
  };

  const toggleEditorPreview = (type) => {
    const unlayer = emailEditorRef.current?.editor;
    if (type === "show") {
      unlayer.showPreview();
    } else if (type === "hide") {
      unlayer.hidePreview();
    }
  };

  return (
    <>
      <div
        className="setting-main"
        style={{ padding: 0, gap: 37, width: "100%", height: "100%" }}
      >
        <div className="left-menu-div vh-100">
          <div className="setting-menu-sidebar-main">
            <div className="mt-5">
              <Link
                onClick={() => {
                  setEditCommunications(false);
                  setEnableEdit(false);
                  dispatch(setTagType("communications"));
                  setCurrentId(null);
                }}
              >
                <div
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <div className="pl-5">
                    <span className="title communication-title">
                      Communication preferences
                    </span>
                  </div>
                </div>
              </Link>
            </div>
            <div>
              <Link
                onClick={() => {
                  setEditCommunications(false);
                  setEnableEdit(false);
                  dispatch(setTagType("twiliio"));
                  setCurrentId(null);
                }}
              >
                <div
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <div className="pl-5">
                    <span className="title communication-title">
                    Twilio  Setup
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div
          className="settings-details"
          style={{ marginRight: "14px", height: "557px" }}
        >
          {tagType === "communications" && (
            <CommunicationSection formik={formik} />
          )}
          {tagType === "twiliio" && (
            <TwiliioSetup isActive={editCommunications} formik={formik} setIsTwilioFieldCleared={setIsTwilioFieldCleared} />
          )}
          {tagType !== "communications" && tagType !== "twiliio" ? (
            <div className="form-group col-md-12 overflow-auto h-100">
              <div className="email-section-wrapper">
                <InputField
                  label="Reply to email"
                  type="text"
                  formik={formik}
                  message={"Please enter valid email"}
                  value={formik?.values?.replyTo}
                  onChange={(e) => handleOnChange(e?.target?.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                  isDisabled={formik?.values?.useDefault}
                  style={{
                    width: "230px",
                    height: "35px",
                  }}
                  styleWrapper={{
                    display: "flex",
                    flexDirection: "column",
                    paddingLeft: "1px",
                    justifyContent: "center",
                    marginLeft: "20px",
                  }}
                  Wrapper={{ flexDirection: "row", alignItems: "baseline" }}
                  labelStyle={{
                    color:
                      !enableEdit || formik?.values?.useDefault
                        ? "var(--Gray-100, #9e9ead)"
                        : "black",
                    fontSize: "12px",
                    fontWeight: 400,
                  }}
                  error={formik.values?.error}
                />
                <div className="use-default" style={{ display: "flex", alignItems: "center" }}>
                  <CheckBox
                    checked={formik?.values?.useDefault}
                    onChange={() => {
                      formik.setFieldValue(
                        "useDefault",
                        !formik?.values?.useDefault
                      );
                      formik.setFieldValue("replyTo", "");
                      formik.setFieldValue("error", false);
                    }}
                    text="use default"
                  />
                  <InfoTooltip text="Uses the organization's default reply-to address instead of a custom one for this template." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
              </div>
              {!oneTemplateLoading && (
                <Editor
                  setJsonContent={setJsonContent}
                  setHtmlContent={setHtmlContent}
                  preview={enableEdit}
                  jsonContent={jsonContent}
                  tokenList={tokenList}
                  emailEditorRef={emailEditorRef}
                />
              )}
              {enableEdit && (
                <textarea
                  style={{ display: "none" }}
                  disabled
                  ref={(value) => setDescriptionValue(value)}
                  value={draftToHtml(
                    convertToRaw(description?.getCurrentContent())
                  )}
                />
              )}
            </div>
          ) : (
            <></>
          )}

          <div className="buttons-wrapper-setting">
            {buttons.map((item, index) => (
              <Button
                key={index}
                type={item?.type}
                variant={item.variant}
                size="md"
                onClick={item?.action}
                disabled={item?.isDisabled}
                style={{
                  marginRight: item?.marginRight || 20,
                  minWidth: item?.width,
                }}
              >
                {
                  updateTemplateLoading && item?.name === "Save" ? (
                    <BeatLoader color="#fff" size={6} />
                  ) : (
                    item?.name
                  )
                }
              </Button>
            ))}
          </div>
        </div>
        <AlertDialog
          open={confirmDeleteOpen}
          onDecline={() => {
            setConfirmDeleteOpen(false);
          }}
          onAccept={() => {
            deleteTemplate(currentId);
            setConfirmDeleteOpen(false);
          }}
          content={`Are you sure?`}
          description={"Do you want to delete this template?"}
        />
      </div>
    </>
  );
};

export default TemplatesSetting;
